import { Button } from '@dnb/eufemia';
import { close } from '@dnb/eufemia/icons';

import { SwitchContainerModeRef } from '@/types/SwitchContainerModeTypes';

interface FormCancelButtonProps {
  switchContainerModeRef: SwitchContainerModeRef;
  onCancel?: () => void;
}

export function FormCancelButton({ switchContainerModeRef, onCancel }: FormCancelButtonProps) {
  const handleClick = () => {
    if (onCancel) {
      onCancel();
    }
    switchContainerModeRef.current?.('view');
  };

  return (
    <Button icon={close} icon_position="left" onClick={handleClick} variant="tertiary">
      Cancel
    </Button>
  );
}
